import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'banner-small',
  styleUrl: 'banner-small.css',
  shadow: true,
})
export class BannerSmall {
  /**
   * The title
   */
  @Prop() mainTitle: string;


  /**
   * The description
   */
  @Prop() description: string;

  /**
   * Buttons Data
   */
  @Prop() buttonsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Image alt
   */
  @Prop() imageAlt: string;

  /**
   * Image Url
   */
  @Prop() imageUrl: any;

  /**
   * Video
   */
  @Prop() videoUrl: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  /** 
   * wordCountTrim - Trims a string to a maximum length, attempting to avoid cutting words in half
  */
  wordCountTrim(str, maxLength) {
    if (str.length <= maxLength) return str;
  
    // Attempt to find the last space before maxLength to avoid cutting a word
    const lastSpaceIndex = str.slice(0, maxLength + 1).lastIndexOf(' ');
  
    // If a space is found, and it's not the very first character, trim up to this space
    if (lastSpaceIndex > 0) return str.slice(0, lastSpaceIndex) + '...';
  
    // If no suitable space is found, or the only space is at the very start, return the original method
    return str.slice(0, maxLength) + (str.length > maxLength ? '...' : '');
  }

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }
  render() {
    const buttons = JSON.parse(this.buttonsData);

    return (
      <Host>
        <div class={`container banner-small-wrapper ${this.paddingBottom} ${this.paddingTop}`}>
          <div class={`banner-small ${this.textColor} ${this.backgroundColor}`} style={{ backgroundImage: `url(${this.backgroundImage})` }}>
            <div class={`banner-small-content ${buttons.length <= 0 ? 'banner-small-content-centered' : ''}`}>
              {this.mainTitle && <h1 class={`banner-small-title `}>{this.mainTitle}</h1>}
              {this.description && <div class={`banner-small-description fs-1`} innerHTML={this.description}></div>}
              {buttons && buttons.length > 0 && (
                <div class="flex flex-wrap gap-12px mt-32px items-center">
                  {buttons.map(button => (
                    <button-block buttonsData={button}></button-block>
                  ))}
                </div>
              )}
            </div>
            <div class={`banner-small-asset-wrapper`}>
              {this.assetType === 'image' && this.imageUrl && <image-block imageUrl={this.imageUrl} imageAlt={this.imageAlt} imageClass={`banner-small-asset`}></image-block>}
              {this.assetType === 'video' && this.videoUrl && <video-block videoUrl={this.videoUrl} videoLoop='true'></video-block>}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
